import { IAIChatSupabaseMessageResponse } from "@/shared/services/interface/responses/IAIChat";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPopoverState {
  isOpenEditPopover: boolean;
  isAIPopoverOpen: boolean;
  ai: {
    messages: IAIChatSupabaseMessageResponse[];
    oldMessages: IAIChatSupabaseMessageResponse[];
  };
  isSharePopoverOpen: boolean;
  isProductPopoverOpen: boolean;
  isSearchPopoverOpen: boolean;
  isDownloadPopoverOpen: boolean;
  isInviteListPopoverOpen: boolean;
  isSavePopoverOpen: boolean;
  isTemplatePopoverOpen: boolean;
  isScoreUpdate: boolean;
  addProductOpen: boolean;
  isRediscoverPopoverOpen: boolean;
}

const initialState: IPopoverState = {
  isOpenEditPopover: false,
  isAIPopoverOpen: false,
  ai: {
    messages: [],
    oldMessages: [],
  },
  isSharePopoverOpen: false,
  isProductPopoverOpen: false,
  isSearchPopoverOpen: false,
  isDownloadPopoverOpen: false,
  isInviteListPopoverOpen: false,
  isSavePopoverOpen: false,
  isTemplatePopoverOpen: false,
  isScoreUpdate: true,
  addProductOpen: false,
  isRediscoverPopoverOpen: false,
};

export const popoverSlice = createSlice({
  name: "popover",
  initialState,
  reducers: {
    setIsScoreUpdate: (state, action: PayloadAction<boolean>) => {
      state.isScoreUpdate = action.payload;
    },
    setAddProductOpenStatus: (state, action: PayloadAction<boolean>) => {
      state.addProductOpen = action.payload;
    },
    setIsOpenEditPopover: (state, action: PayloadAction<boolean>) => {
      state.isOpenEditPopover = action.payload;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsAIPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isAIPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsSharePopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isSharePopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsProductPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isProductPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
    },
    setIsSearchPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isSearchPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsDownloadPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isDownloadPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsSavePopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isSavePopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsRediscoverPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isRediscoverPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
    },
    setIsInviteListPopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isInviteListPopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setIsTemplatePopoverOpen: (state, action: PayloadAction<boolean>) => {
      state.isTemplatePopoverOpen = action.payload;
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
    setAIMessages: (
      state,
      action: PayloadAction<IAIChatSupabaseMessageResponse[]>
    ) => {
      state.ai.messages = action.payload;
    },
    setAINEWMessages: (
      state,
      action: PayloadAction<IAIChatSupabaseMessageResponse[]>
    ) => {
      state.ai.messages = action.payload;
    },
    setAIOldMessages: (
      state,
      action: PayloadAction<IAIChatSupabaseMessageResponse[]>
    ) => {
      state.ai.oldMessages = action.payload;
    },
    clearPopovers: (state) => {
      state.isOpenEditPopover = false;
      state.isAIPopoverOpen = false;
      state.isSharePopoverOpen = false;
      state.isProductPopoverOpen = false;
      state.isSearchPopoverOpen = false;
      state.isDownloadPopoverOpen = false;
      state.isInviteListPopoverOpen = false;
      state.isSavePopoverOpen = false;
      state.isTemplatePopoverOpen = false;
      state.isRediscoverPopoverOpen = false;
    },
  },
});

export const {
  setIsAIPopoverOpen,
  setIsSharePopoverOpen,
  setIsProductPopoverOpen,
  setIsSearchPopoverOpen,
  setIsDownloadPopoverOpen,
  setIsSavePopoverOpen,
  setIsInviteListPopoverOpen,
  setAIMessages,
  setIsOpenEditPopover,
  setIsTemplatePopoverOpen,
  clearPopovers,
  setIsScoreUpdate,
  setAddProductOpenStatus,
  setAIOldMessages,
  setAINEWMessages,
  setIsRediscoverPopoverOpen,
} = popoverSlice.actions;

export default popoverSlice.reducer;
